import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of, Subscription } from 'rxjs';
import { getAvailableActiveBranches, getCurrentTenant, getIsConnectionStarted, getLobbyLocationSelctorStatus, getLobbyLocationSelected, getLobbyShowCategory, getLocationSelected, getLoggedInUserId, getLoggedInUserInfo, getLoggedInUserNotificationGroup, getSignedInStatus, getSystemConfigurations, GetUserPermissionList } from 'src/app/state';
import { CentralLobbyGridRequest } from '../shared/models/central-lobby.request.model';
import { getCenralLobySelectedLocationIds, getCentralLobbyViewGridData } from '../state';
import * as LobbyCentralLobbyViewActions from '../state/actions/lobby-central-views.actions';
import * as _ from 'lodash';
import { SortDescriptor } from '@progress/kendo-data-query';
import { CentralLobbyViewGridData } from '../shared/models/central-lobby-response.model';
import { LWAReasonService } from 'src/app/admin/lwa-reasons/shared/services/left-without-assistant-reasons.service';
import { LWAReason } from 'src/app/admin/lwa-reasons/shared/models/left-without-assistant-reasion.model';
import { LWAModel } from '../shared/models/lwa-model';
import { LobbyEntryService } from '../../shared/services/lobby-entry.service';
import * as LobbyWrapUpPageActions from '../../lobby-wrap-up/state/actions/wrap-up-page.actions';
import { State } from 'src/app/state/app.state';
import { UserSigninStatus } from 'src/app/shared/enums/UserSigninStatus.enum';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { MapSigninStatus } from 'src/app/shared/mappers/signinstatus.mapper';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { ToastService } from 'src/app/shared/services/toast.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { LocationSelectorItem } from 'src/app/shared/models/location-selector/location-selector-item-model';
import { LocationStateModel } from 'src/app/shared/models/location-selector/location-state.model';
import * as CentralLocationSelectorActions from '../state/actions/lobby-central-view-location-selector.actions';
import { LocationMultiSelector } from 'src/app/shared/models/location-selector/location-multi-selector-model';
import { LocationRelationship } from 'src/app/admin/location/shared/models/locationRelationship';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';
import * as LobbyStaffStatusActions from 'src/app/lobby/lobby-staff-status/state/actions/lobby-staff-status.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { LeftWithoutAssistanceComponent } from 'src/app/shared/modalpopup/left-without-assistance/left-without-assistance.component';
import { LobbyEditComponent } from 'src/app/shared/modalpopup/lobby-edit/lobby-edit.component';
import { UserSigninStatusModel } from '../../shared/models/lobby-user-signin-status.model';
import { getPreferredLanguageId } from 'src/app/appointment/appointment-status-grid/state';

@Component({
  selector: 'app-lobby-central-lobby-view',
  templateUrl: './lobby-central-lobby-view.component.html',
  styleUrls: ['./lobby-central-lobby-view.component.scss']
})
export class LobbyCentralLobbyViewComponent implements OnInit, AfterViewInit {
  public sort: SortDescriptor[] = [{ field: 'locationName', dir: 'asc' }];
  public sortingField: any = [{ field: 'LocationName', dir: 'asc' }];
  public lwaPopUp: boolean = false;
  public assistPopup: boolean = false;
  public productAndServiceView: boolean = false;
  public OnDemandPopup: boolean = false;
  public isMsgContentRequired: boolean = false;
  public message: string = "";
  public remainingText: number = 350;
  public dataItem: any;
  public locationId: number = 0;
  public centralLobbyViewSubscriptions = new Subscription();
  public GridData$?: Observable<CentralLobbyViewGridData>;
  public assistingLobbyRecord: any;
  public productAndServiceData: any;
  public selectedLocations: number[] = [];
  public searchText: string = "";
  public tenantId: number = 0;
  public searchObject: CentralLobbyGridRequest = {} as CentralLobbyGridRequest;
  public allLWAResons: LWAReason[] = [];
  public lwaObject?: LWAModel;
  public selectedLWAResons: LWAReason[] = [];
  public isAssisting:boolean=false;
  public IsSignedIn:boolean=false;
  public userNotificationGroups: number[] = [];
  public assistNotificationPopup:boolean=false;
  public showAccountNumber:boolean=false;
  public enableUserImpersonation:boolean=false;
  public enableUserImpersonationForTenant:boolean=false;
  public currentLocationId: number = 0;
  public currentLocationName: string | null = null;
  public assistingLobbyEntry:any=null;
  showLobbyCateogory: boolean = false;
  
  @ViewChild('randomdiv') input?: ElementRef;

  public pageSize?: number;
  public skip?: number;
  public data: GridDataResult = {} as GridDataResult;
  public userPermissionList?: number[];
  public checkedKeys: any[] = [];
  public selectorDisable: boolean = false;
  private showOnlySpanishSpeakers? : boolean;
  public assistText: any;
  public currentlyAssistingText: any;

  constructor(public lwaService: LWAReasonService, public lobbyEntryService: LobbyEntryService, private store: Store<State>, public toastService: ToastService, private translationLoaderFacade: TranslationLoaderFacade, private translateService: TranslateService) {
    this.translateService.get(['_General_Currently_Assisting_Text_', '_General_Assist_Text_']).subscribe((translations) => {
      this.assistText = translations['_General_Assist_Text_'];
      this.currentlyAssistingText = translations['_General_Currently_Assisting_Text_'];
    }
    );
   }

  ngOnInit() {
    this.showOnlySpanishSpeakers = false
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      this.userPermissionList = allUserPermissions;
    });
    this.store.select(getLobbyLocationSelected).subscribe((location) => {
      this.locationId = location.locationId;
    });
    this.centralLobbyViewSubscriptions.add(this.store.select(getCurrentTenant).subscribe(t => this.tenantId = t.tenantID));
    this.initializeMessageHubConnection();
    this.store.select(getCentralLobbyViewGridData).subscribe(gridData => this._onReceiveData(gridData));
    const signinStatusSubscription = this.store.select(getSignedInStatus)
    .subscribe((status: any) => {
      if (status && (status.statusId === UserSigninStatus.Idle || status.statusId === UserSigninStatus.Assisting)) {
        this.IsSignedIn = true;
       
    } else {
        this.IsSignedIn = false;
      }
    });
    
    const notificationGroupSubscriptions=this.store.select(getLoggedInUserNotificationGroup).subscribe(notificationGroups => {
      if (notificationGroups != null)
        this.userNotificationGroups = notificationGroups;
    });

    const userInfoSubscription = this.store.select(getLoggedInUserInfo).subscribe((userInfo) => {
      if(userInfo!=null){
        this.enableUserImpersonation=userInfo.enableUserImpersonation;       
      }
    });

    const locationSelectorStatusSubscription=this.store.select(getLobbyLocationSelctorStatus).subscribe(status => {
      if(status!=undefined){
        if(this.IsSignedIn && status.isError){
         
          this.isAssisting=status.isAssisting;
         
        }
       else{
          this.isAssisting=false;
        }
  
      }
         
      });
      this.centralLobbyViewSubscriptions.add(
        this.store.select(getSystemConfigurations).subscribe(
          (configurations) => {
            const lobbyConfigurations = configurations.filter(c => c.configurationGroup === 'LobbySettings');
            if (lobbyConfigurations.length > 0) {            
              this.showAccountNumber= this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableAccountNumber'));
              this.enableUserImpersonationForTenant=this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableUserImpersonation'));
            }
          }));
      this.centralLobbyViewSubscriptions.add(notificationGroupSubscriptions);
      this.centralLobbyViewSubscriptions.add(signinStatusSubscription);
      this.centralLobbyViewSubscriptions.add(locationSelectorStatusSubscription);
      this.centralLobbyViewSubscriptions.add(userInfoSubscription);
  }

  public openImpersonateAssist(data: any) {
    this._showUnableToSigninPopup().subscribe(branchesAvailable => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
          if (status) {
            this.currentLocationName=data?.locationName;
            this.currentLocationId=data?.locationId;
            this.assistingLobbyEntry=data;          
            this.store.dispatch(LobbyStaffStatusActions.loadImpersonateUsers({ locationId: this.currentLocationId ,showPopUp:true}));
          }
        });
      }
    }) 
  }

  private readCastedValue(systemConfigValue?: SystemConfigValue): any {
    if (systemConfigValue) {
      switch (systemConfigValue.dataType) {
          case 'int':
              return parseInt(systemConfigValue.value, undefined);
          case 'bool':
              return (systemConfigValue.value === '1');
          default:
              return systemConfigValue.value;
      }
    }
  }

  public handleDefaultSelection(data: LocationMultiSelector) {
  
    var branchArray = data.locationsFlatData.filter(l => l.locationTypeId == 5);
    switch (branchArray.length) {
      case 0:
        this.selectorDisable = true;
        break;
      case 1:
        this.selectorDisable = true;
        this._setLocationSelectorDefaultValue();
        break;
      default:
        this._setLocationSelectorDefaultValue();
        break;
    }






  }
  private _setLocationSelectorDefaultValue() {
    const centralLocationIdsSubscription = this.store.select(getCenralLobySelectedLocationIds).pipe(take(1)).subscribe((location) => {

      this.checkedKeys = location;

    });
    this.centralLobbyViewSubscriptions.add(centralLocationIdsSubscription);
  }
  public handleLocationData(items: LocationSelectorItem[] | any){
   
    var locationStateArray:LocationStateModel[]=[];
    items.forEach(function(v:any) {
      var locateStateObj:LocationStateModel={
        locationId:v.locationId,
        locationName:v.locationName,
        locationTypeId:v.locationTypeId
      };
      locationStateArray.push(locateStateObj);
     

     });
    
    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemSelectAll({selectedLocations: locationStateArray}));
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }

  /**
  * Open Text On Demand Pop Up
  * @param dataItem
  */
    public openTextOnDemandPopup(dataitem: any) {
      //console.log(dataItem);
      this.dataItem = dataitem;
      this.OnDemandPopup = true;
    }

    /**
    * Close Text On Demand Pop Up
    */
    public closeOnDemandTextPopop() {
      this.message = "";
      this.remainingText = 350;
      this.OnDemandPopup = false;
    }

  /**
  *  * Triggers when clicking Send in the Text On Demand Pop Up
  */
  public SendTextOnDemandMessage(value: any) {
    const valueNoWhiteSpace = value.trim();

    if (valueNoWhiteSpace == "") {
      this.isMsgContentRequired = true;
    } else {
      this.isMsgContentRequired = false;
      this.store.select(getLoggedInUserId).subscribe((userId) => {
        this.lobbyEntryService.sendTextOnDemand(this.dataItem.lobbyEntryId, this.message, userId).subscribe((onDemandData) => {
          this.toastService.showSuccess('_General_Message_Sent_Successfully_Ts_Text_');
          this.closeOnDemandTextPopop();
        }, error => {
          this.toastService.showError('_General_Failed_Message_Request_Ts_Text_');
          this.closeOnDemandTextPopop();
        });
      });
    }
  }


  public GetRemaningTextCount(value: number) {
    if (value === 0) {
      this.message = "";
      this.isMsgContentRequired = true;
    } else {
      this.isMsgContentRequired = false;
    }
    this.remainingText = 350 - value;
  }

  private _setDefaultValues() {
    this.sort = [{ field: 'locationName', dir: 'asc' }];
    this.sortingField = this.sort[0];
    this.pageSize = 10;
    this.skip = 0;
    this.searchText = '';
  }

  private _onReceiveData(gridData: CentralLobbyViewGridData) {
    if (gridData) {
      this.data = {
        data: gridData.data ?? [],
        total: gridData.totalRowCount ?? 0
      };
      this.pageSize = gridData.pageSize ?? 1;
      this.skip = (gridData.currentPageNumber - 1) * this.pageSize
    } else {
      this._setDefaultValues();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let inputElement: HTMLElement = this.input?.nativeElement as HTMLElement;
      inputElement.click();
    }, 500);
  }


  /**
   * Initialize SignalR Connection and Subscribe
   */
  public initializeMessageHubConnection() {
    const signalRConnectionSubscription = this.store.select(getIsConnectionStarted).subscribe(
      isHubConnected => {
        if (isHubConnected) {
          this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({ gridParams: this.getLobbyCentralGridViewDataForInitially() }));
        }
      });
    this.centralLobbyViewSubscriptions.add(signalRConnectionSubscription);

    const getLocationSubs = this.store.select(getCenralLobySelectedLocationIds).subscribe((location) => {
      if (this.selectedLocations.length !== location.length || !_.isEqual(this.selectedLocations, location)) {
        this.selectedLocations = location;
        this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({ gridParams: this.getLobbyCentralGridViewDataForInitially() }));
      }

    });
    const getLobbyCategorySub = this.store.select(getLobbyShowCategory).subscribe((lobbyCategory) => {
     
        this.showLobbyCateogory=lobbyCategory;

    });
    this.centralLobbyViewSubscriptions.add(getLocationSubs);
    this.centralLobbyViewSubscriptions.add(getLobbyCategorySub);
  }

  /**
   * Generate central lobby initial request
   */
  public getLobbyCentralGridViewDataForInitially() {
    let initialSearchObject: CentralLobbyGridRequest = <CentralLobbyGridRequest>{};
    if(this.selectedLocations!=null && this.selectedLocations.length>0){
      initialSearchObject.LocationFilters = this.selectedLocations;
    }
    else{
      initialSearchObject.LocationFilters = [0];
    }
    
    initialSearchObject.Page = 1;
    initialSearchObject.PageSize = 25
    initialSearchObject.SearchText = this.searchText;
    initialSearchObject.SortColumn = this.sortingField[0].field;
    initialSearchObject.SortDirection = this.sortingField[0].dir == 'asc' ? 'Ascending' : 'Descending';
    initialSearchObject.TenantId = this.tenantId;
    initialSearchObject.PreferredLanguage = this.showOnlySpanishSpeakers ? 3 : null;
    this.store.select(getPreferredLanguageId).pipe(take(1)).subscribe((langId: number) => {
      initialSearchObject.PreferredLanguageId = langId;
    });
    this.searchObject = JSON.parse(JSON.stringify(initialSearchObject));
    return initialSearchObject;
  }

  /**
   * Triggers when user click the search button.
   * @param event 
   */
  public searchKeyWordChange() {
    console.log(this.searchText);
    this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { SearchText: this.searchText }
      )
    }));
  }

  /**
  * Triggers when user click the clear search button.
  *  
  */
  public clearSearchFilter() {
    this.searchText = '';
    this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { SearchText: this.searchText }
      )
    }));
  }




  /**
   * Triggers when user changes the page of the grid
   * @param event
   */
  public onPageChange(event: any) {
    this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { Page: (event.skip / event.take) + 1, PageSize: event.take }
      )
    }));
  }

  /**
 * Triggers when sort changed by the user
 * @param sort 
 */
  public sortChange(sort: SortDescriptor[]) {
    this.sort = sort;
    switch (sort[0].field) {
      case 'locationName':
        this.sortingField[0].field = 'LocationName';
        break;
      case 'accountNumber':
        this.sortingField[0].field = 'AccountNumber';
        break;
      case 'firstName':
        this.sortingField[0].field = 'FirstName';
        break;
      case 'lastName':
        this.sortingField[0].field = 'LastName';
        break;
      case 'personRequested':
        this.sortingField[0].field = 'PersonRequested';
        break;
      case 'serviceRequested':
        this.sortingField[0].field = 'ServiceRequested';
        break;
      case 'waitTime':
        this.sortingField[0].field = 'WaitTime';
        break;

    }
    let newSearchObject = _.cloneDeep(this.searchObject)
    newSearchObject.SortColumn = this.sortingField[0].field;
    newSearchObject.SortDirection = sort[0].dir == undefined ? 'asc' : sort[0].dir
    this.searchObject = newSearchObject;

    if (newSearchObject != null) {
      this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({
        gridParams: newSearchObject
      }));
    }
  }


  /**
   * Language
   * 1 - English 3 - Spanish
   * @param event 
   */
  public spanishPreffered(event: any) {
    if (event.currentTarget.checked) {
      this.showOnlySpanishSpeakers = true;
      this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({
        gridParams: Object.assign({}, this.searchObject,
          { PreferredLanguage: 3 }
        )
      }));
    } else {
      this.showOnlySpanishSpeakers = false;
      this.store.dispatch(LobbyCentralLobbyViewActions.loadCentralLobbyViewGridData({
        gridParams: Object.assign({}, this.searchObject,
          { PreferredLanguage: null }
        )
      }));
    }


  }

  public submitLeftWithoutAssistant() {

  }

  public closeLeftWithoutAssistant() {
    this.lwaPopUp = false;
    this.selectedLWAResons = [];
  }


  public openLeftWithoutAssistant(event: any) {
    console.log(event);
    if ((event.firstName && event.lastName && event.locationName)) {
      this.lwaObject = { 'firstName': event.firstName, 'lastName': event.lastName, 'locationName': event.locationName }
      this.lwaService.getLwaReasons().subscribe((allLWAdata: LWAReason[]) => {
        this.allLWAResons = allLWAdata;
        this.lwaPopUp = true;
      })
    }

  }

  public checkValue(event: any) {
    console.log(event);

  }

  public checkedChangedEvent(event: any, i: any) {
    if (event.currentTarget.checked) {
      this.selectedLWAResons.push(i);
    } else {
      let foundIndex = this.selectedLWAResons.findIndex((item) => item === i.id);
      this.selectedLWAResons.splice(foundIndex, 1);
    }
  }

  public openPopUp(popUp: LeftWithoutAssistanceComponent, dataItem: any) {
    this._showUnableToSigninPopup().subscribe(branchesAvailable => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
          if (status) {
            let lwaObject = { 'firstName': dataItem.firstName, 'lastName': dataItem.lastName, 'locationName': dataItem.locationName }
            popUp.open();
            popUp.lwaObject = lwaObject;
            popUp.dataItem = dataItem;
          }
        });  
      }
    })
  }


  public openLobbyEdit(popUp: LobbyEditComponent, dataItem: any) {
    this._showUnableToSigninPopup().subscribe(branchesAvailable => {
      if (branchesAvailable) {
        popUp.dataItem = dataItem;
        this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
          if (status) {
            popUp.open();
          }
        });
      }
    })
  }

  public openAssist(event: any) {
    this._showUnableToSigninPopup().subscribe(branchesAvailable => {
      if (branchesAvailable) {
        this.assistingLobbyRecord = event;
        this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
          if (status) {
            this.store.select(getLoggedInUserId)
              .subscribe((userId: any) => {             
                if (this.assistingLobbyRecord !== null &&
                    (userId === this.assistingLobbyRecord.personRequestedId || this.assistingLobbyRecord.personRequestedId === null)) {
                      if(this.assistingLobbyRecord.groupRequestedId > 0 && this.userNotificationGroups.indexOf(this.assistingLobbyRecord.groupRequestedId)===-1){
                        this.assistNotificationPopup=true;
                      }
                      else{
                        this.store.dispatch(LobbyWrapUpPageActions.assistLobbyEntry({
                          lobbyEntryId: this.assistingLobbyRecord.lobbyEntryId,
                          assistingUserId: userId,
                          isInstantAssist: false,
                          locationId: this.locationId,
                          showLobbyCategory: this.showLobbyCateogory,
                          isImpersonateAssist: false,
                          impersonateByName: null
                        }));
                        this.assistingLobbyRecord = null;
                      }
                } else {
                  this.assistPopup = true;
                }
              });
          }
          
        });
      }
    })
  }

  private _showSigninPopupIfNotSignedInAlready(): Observable<boolean> {
    return this.store.select(getSignedInStatus).
      pipe(
        map((signInStatus) => MapSigninStatus(signInStatus)),
        take(1), // This would remove the need for the subscriber to unsubscribe
        tap(status => {
          if (!status) {
            this.store.dispatch(CoreActions.promptUserToSignin({payload:{isSelectorChange:false}}));
          }
        })
      );
  }

  private _showUnableToSigninPopup(): Observable<boolean> {
    return this.store.select(getAvailableActiveBranches)
      .pipe(
        tap((b:LocationRelationship[]) => {
          if (b.length == 0) this.store.dispatch(CoreActions.promptUnableToSignin());
        }),
        switchMap(b => of(b.length > 0))
      );
  }

  public submitNo() {
    this.assistPopup = false;
    this.assistNotificationPopup=false;
  }

  public submitYes() {
    this.assistPopup = false;
    this.assistNotificationPopup=false;
    this.store.select(getLoggedInUserId).subscribe((userId) => {
      if (userId != undefined) {
        this.store.dispatch(LobbyWrapUpPageActions.assistLobbyEntry({
          lobbyEntryId: this.assistingLobbyRecord.lobbyEntryId,
          assistingUserId: userId,
          isInstantAssist: false,
          locationId:this.locationId,
          showLobbyCategory:this.showLobbyCateogory,
          isImpersonateAssist:false,
          impersonateByName:null
        }));
      }
    })
  }


  public closeProductServiceDialog() {
    this.productAndServiceView = false;
  }


  public openProductServiceDialog() {
    this.productAndServiceView = true;
  }

  public productClickedHandler(event: any) {
    this.lobbyEntryService.getLobbyEntryDetails(event.lobbyEntryId).subscribe((lobbyEntryData) => {
      this.productAndServiceData = lobbyEntryData;
      this.openProductServiceDialog();
    });
  }


  public toastError() {
    this.toastService.show('_General_Currently_Assisting_Text_', {
      classname: 'cc-alert-danger cc-alert ',
      delay: 3500,
      autohide: true,
    });
  }

onComplete(data: any) {
  console.log('Timer complete.');
}


onTick(data: any) {
  console.log('Timer tick.');
}

onStart(data: any) {
  console.log('Timer started.');
}

onStop(data: any) {
  console.log('Timer stop.');
}

ngOnDestroy() {  
  const groupNames = [      
    'CentralLobbyEntryGridGroup'
  ];
  this.store.dispatch(CoreActions.unsubscribeFromSignalRGroups({ groupNames }));
}

  public updateRemoteCheckedInVisitorStatus(event: any, isArrived: boolean) {
    this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
      if (status) {
        this.store.dispatch(LobbyWrapUpPageActions.isVisitorArrived({
          lobbyEntryId: event.lobbyEntryId,
          isArrived: isArrived
        }));
      }
    });
  }
}
